// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oyA_","label":"styles_label__1AG98"};